import request from "_private/utils/request";
// let mock = "/mock/5c7fb1b653377c002106962b";
let mock = "";
//请求  车辆列表
const fetchVehicleList = function (data) {
    return request({
        url: mock + "/monitorCenter/track/getVehicleList",
        method: "post",
        headers: {
            type: "json"
        },
        data
    });
};
// 请求 轨迹线 数据
const fetchTrackList = function (data) {
    return request({
        url: mock + "/monitorCenter/track/getTrackLineList",
        method: "post",
        headers: {
            type: "json"
        },
        data
    });
};
// 请求  轨迹点列表
const fetchTrackTableList = function (data) {
    return request({
        url: mock + "/monitorCenter/track/getTrackTableList",
        method: "post",
        headers: {
            type: "json"
        },
        data
    });
};
// 请求 停车点 列表
const fetchStopTableList = function (data) {
    return request({
        url: mock + "/monitorCenter/track/getStopTableList",
        method: "post",
        headers: {
            type: "json"
        },
        data
    });
};
// 请求 进出区域 列表数据
const fetchAreaTableList = function (data) {
    return request({
        url: mock + "/monitorCenter/track/getAreaTableList",
        method: "post",
        headers: {
            type: "json"
        },
        data
    });
};
// 请求 报警列表 数据
const fetchAlarmTableList = function (data) {
    return request({
        url: mock + "/monitorCenter/track/getAlarmTableList",
        method: "post",
        headers: {
            type: "json"
        },
        data
    });
};

// 请求 闪拍列表 数据
const fetchPhotoTableList = function (data) {
    return request({
        url: mock + "/monitorCenter/track/getOurCamDetailList",
        method: "post",
        headers: {
            type: "json"
        },
        data
    });
};

// 请求 主动安全事件列表 数据
const fetchSecurityTableList = function (data) {
    return request({
        url: mock + "/monitorCenter/track/getActiveSafetyEventList",
        method: "post",
        headers: {
            type: "json"
        },
        data
    });
};

// 异步 更新轨迹列表的地理位置
const fetchPositionByLonLat = function (data) {
    return request({
        url: mock + "/monitorCenter/monitorVehicle/getPositionByLonLat",
        method: "post",
        headers: {
            type: "json"
        },
        data
    });
};

// 异步 更新轨迹列表的地理位置
const fetchTemperatureNumData = function (data) {
    return request({
        url: mock + "/monitorCenter/track/getVehicleTemperatureNumData",
        method: "post",
        headers: {
            type: "json"
        },
        data
    });
};

// 异步 更新轨迹列表的地理位置
const fetchHumidityNumData = function (data) {
    return request({
        url: mock + "/monitorCenter/track/getVehicleHumidityNumData",
        method: "post",
        headers: {
            type: "json"
        },
        data
    });
};

// // 导出轨迹
const exportTrackList = function (data) {
    let exportUrl =
        mock +
        "/monitorCenter/track/exportTrackList?vehicleId=" +
        data.vehicleId +
        "&startTime=" +
        data.startTime +
        "&endTime=" +
        data.endTime +
        "&distance=" +
        data.distance +
        "&second=" +
        data.second +
        "&stopSecond=" +
        data.stopSecond;
    document.location.href = exportUrl;
};

export default {
    fetchVehicleList,
    fetchTrackList,
    fetchTrackTableList,
    fetchStopTableList,
    fetchAreaTableList,
    fetchAlarmTableList,
    fetchPhotoTableList,
    fetchSecurityTableList,
    fetchPositionByLonLat,
    exportTrackList,
    fetchTemperatureNumData,
    fetchHumidityNumData
};
